// Change #100463 - a renewal date with a small pill under it: "in 5 days",
// "tomorrow", "today", "3 days overdue", or "paused". Used wherever a next
// renewal is shown (Subscriptions, Manage Licence) instead of "Expired".

import React from "react";
import { Badge } from "reactstrap";

import HandleDateTime from "../HandleDateTime";

// The calendar day of a stamp: "YYYY-MM-DD ..." (the API) or "DD/MM/YYYY ..."
// (already formatted). Anything else falls back to Date(); null if unreadable.
const dayOf = (v) => {
  const t = String(v).trim();
  let m = t.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  m = t.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (m) return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
  const d = new Date(t.replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return null;
  d.setHours(0, 0, 0, 0);
  return d;
};

// A gap in words that grows with it: days up to 2 weeks, then weeks, then
// whole months, then years (+ months), e.g. "12 days", "3 weeks",
// "4 months", "1 year 2 months". later > earlier.
const plural = (n, w) => `${n} ${w}${n === 1 ? "" : "s"}`;
const spanText = (later, earlier, days) => {
  if (days < 14) return plural(days, "day");
  let months = (later.getFullYear() - earlier.getFullYear()) * 12 + (later.getMonth() - earlier.getMonth());
  if (later.getDate() < earlier.getDate()) months -= 1;
  if (months < 1) return plural(Math.floor(days / 7), "week");
  if (months < 12) return plural(months, "month");
  const years = Math.floor(months / 12);
  const rest = months % 12;
  return rest ? `${plural(years, "year")} ${plural(rest, "month")}` : plural(years, "year");
};

export default function RenewalWhen({ at, paused = false }) {
  if (!at || String(at) >= "9999") return <span className="text-muted">-</span>;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const day = dayOf(at);
  if (!day) return <span>{HandleDateTime(at)}</span>;
  // A placeholder / zero date (e.g. 0000-00-00 or 1899) is "no date", not
  // "overdue by 46,000 days".
  if (day.getFullYear() < 2000) return <span className="text-muted">-</span>;
  const days = Math.round((day - today) / 86400000);
  const text =
    days === 0
      ? "today"
      : days === 1
      ? "tomorrow"
      : days > 1
      ? `in ${spanText(day, today, days)}`
      : `overdue by ${spanText(today, day, -days)}`;
  const cls = paused
    ? "badge-soft-secondary"
    : days < 0
    ? "badge-soft-danger"
    : days <= 7
    ? "badge-soft-warning"
    : "badge-soft-success";
  return (
    <div>
      <div>{HandleDateTime(at)}</div>
      <Badge color="" className={`${cls} rounded-pill fs-11`}>
        {paused ? "paused" : text}
      </Badge>
    </div>
  );
}
